import React from 'react'

import styled from 'styled-components'
import { SavingsOutlined } from '@mui/icons-material'

import Tooltip from 'components/Tooltip'

import { color } from 'styles/colors'

type Props = {
  showTooltip?: boolean
}

const EnrolledIcon = ({ showTooltip = false }: Props) => {
  const Icon = <S.EnrolledIcon aria-label="enrolled-icon" />

  return (
    <>
      {showTooltip ? (
        <Tooltip
          title="Customer has enrolled in a Utility Savings Program or Demand Response."
        >
          {Icon}
        </Tooltip>
      ) : (
        Icon
      )}
    </>
  )
}

export default EnrolledIcon

const S = {
  EnrolledIcon: styled(SavingsOutlined)`
    color: ${color('enrolledIcon')};
    background-color: ${color('enrolledBackground')};
    border-radius: 50%;
    padding: 4px;
    margin-right: 20px;
    font-size: 3em;
  `
}
